// geolocation.js
import store from '@/store'
import router from '@/router'
import session from '../store/modules/session'

function calculateDistance(lat1, lon1, lat2, lon2) {
  lat1 = parseFloat(lat1)
  lon1 = parseFloat(lon1)
  lat2 = parseFloat(lat2)
  lon2 = parseFloat(lon2)

  const factorRounded = Math.pow(10, 5)
  const latitudeDeviceRounded =
    Math.round((lat2 + Number.EPSILON) * factorRounded) / factorRounded
  const longitudeDeviceRounded =
    Math.round((lon2 + Number.EPSILON) * factorRounded) / factorRounded

  const R = 6371 * 1000
  const dLat = (latitudeDeviceRounded - lat1) * (Math.PI / 180)
  const dLon = (longitudeDeviceRounded - lon1) * (Math.PI / 180)
  const a =
    Math.sin(dLat / 2) * Math.sin(dLat / 2) +
    Math.cos(lat1 * (Math.PI / 180)) *
      Math.cos(latitudeDeviceRounded * (Math.PI / 180)) *
      Math.sin(dLon / 2) *
      Math.sin(dLon / 2)
  const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a))
  const distance = R * c
  return distance
}

async function checkGeolocationPermissions(to, from, next) {
  let allowedGeolocation = store.getters['getAllowGeolocation']
  let allowedGeolocationRange = store.getters['getAllowGeolocationRange']

  if (allowedGeolocation === null || allowedGeolocationRange === null) {
    await geolocation()
    allowedGeolocation = store.getters['getAllowGeolocation']
    allowedGeolocationRange = store.getters['getAllowGeolocationRange']
  }

  if (!allowedGeolocation) {
    next('/geolocation')
  } else if (allowedGeolocation && allowedGeolocationRange) {
    next()
  } else if (allowedGeolocation && !allowedGeolocationRange) {
    store.dispatch('updateGeolocationRangeModal', true)
    next('/')
  }
}

async function geolocationRangeTimeout() {
  let storeDeviceRangeTimeout = store.getters['getDeviceRangeTimeout']
  if (storeDeviceRangeTimeout) {
    return storeDeviceRangeTimeout
  } else {
    try {
      let storeLatitude = store.getters['getDeviceLatitude']
      let storeLongitude = store.getters['getDeviceLongitude']
      let storeRange = store.getters['getDeviceRange']

      // CHECK THE RANGE IN METERS
      const distance =
        Math.round(
          calculateDistance(
            session.state.latitude,
            session.state.longitude,
            storeLatitude,
            storeLongitude
          ) / 100
        ) * 100

      console.log('Distance: ' + distance + 'm')
      if (distance <= storeRange) {
        store.dispatch('updateGeolocationRangeTimeout', false)
        return false
      } else if (distance > storeRange) {
        store.dispatch('updateGeolocationRangeTimeout', true)
        return true
      }
    } catch (error) {
      console.log('Error obtaining location', error.message)
    }
  }
}

async function geolocation() {
  let storeLatitude = store.getters['getDeviceLatitude']
  let storeLongitude = store.getters['getDeviceLongitude']
  let storeRange = store.getters['getDeviceRange']

  if (!storeLatitude || !storeLongitude || !storeRange) {
    store.dispatch('updateGeolocationRangePermission', false)

    /*
     * Sin aparato dado de alta no hay modo tienda que comprobar, y **sin
     * coordenadas no es lo mismo que fuera de rango**.
     *
     * Esto es logica de totem: el totem esta dentro de la tienda, su aparato
     * tiene latitud, longitud y radio, y si se sale de ahi se le devuelve a la
     * portada. En la web publica no hay aparato: los tres getters son `null`
     * siempre, asi que esta rama se cumplia SIEMPRE.
     *
     * Y se cumplia en cada clic. `App.vue` engancha `checkActivityUser` a
     * `click` y a `touchstart` de `window` -no a un boton, a la ventana- y de
     * ahi se llama a esto. Resultado: pulsar en cualquier sitio de la web
     * -una tarjeta sin enlace, un titulo, el fondo- hacia `router.push('/')`
     * y el visitante aparecia arriba del todo de la portada sin haber pedido
     * ir a ninguna parte. Se nota sobre todo abajo, en «Descubre el espacio»,
     * porque es donde el salto se ve.
     *
     * El totem sigue igual: alli hay `deviceId`.
     */
    if (!store.state.common.deviceId) return

    return router.push('/')
  }

  // CHECK THE RANGE IN METERS
  const distance =
    Math.round(
      calculateDistance(
        session.state.latitude,
        session.state.longitude,
        storeLatitude,
        storeLongitude
      ) / 100
    ) * 100

  if (distance <= storeRange) {
    store.dispatch('updateGeolocationRangePermission', true)
  } else {
    store.dispatch('updateGeolocationRangePermission', false)
  }

  return geolocation
}

function calculateDistanceLocation(
  storeLatitude,
  storeLongitude,
  userLatitude,
  userLongitude
) {
  return (
    Math.round(
      calculateDistance(
        userLatitude,
        userLongitude,
        storeLatitude,
        storeLongitude
      ) / 100
    ) * 100
  )
}

export {
  geolocation,
  checkGeolocationPermissions,
  geolocationRangeTimeout,
  calculateDistanceLocation
}
